import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useEffect, useState } from "react";
import { toast } from "sonner";
import api, { errorMessage } from "@/lib/api";
import { X, Plus } from "lucide-react";

export function SettingsModal({ open, onClose, onSaved }) {
  const [cardParado, setCardParado] = useState(3);
  const [ddd, setDdd] = useState("11");
  const [intencoes, setIntencoes] = useState([]);
  const [novaInt, setNovaInt] = useState("");
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (!open) return;
    api.get("/salao/settings").then(({ data }) => {
      setCardParado(data.card_parado_dias ?? 3);
      setDdd(data.ddd_padrao ?? "11");
      setIntencoes(data.intencoes || []);
    }).catch(() => {});
  }, [open]);

  const save = async () => {
    setSaving(true);
    try {
      await api.put("/salao/settings", {
        card_parado_dias: Number(cardParado) || 3,
        ddd_padrao: String(ddd || "11"),
        intencoes: intencoes.filter(Boolean),
      });
      toast.success("Configurações salvas");
      onSaved && onSaved();
      onClose();
    } catch (e) {
      toast.error(errorMessage(e, "Erro ao salvar"));
    } finally {
      setSaving(false);
    }
  };

  const addIntencao = () => {
    const v = novaInt.trim();
    if (!v) return;
    if (intencoes.includes(v)) return;
    setIntencoes([...intencoes, v]);
    setNovaInt("");
  };

  return (
    <Dialog open={open} onOpenChange={(o) => { if (!o && !saving) onClose(); }}>
      <DialogContent className="max-w-md" data-testid="settings-modal">
        <DialogHeader>
          <DialogTitle className="text-zinc-100 text-base font-semibold">Configurações do salão</DialogTitle>
        </DialogHeader>
        <div className="space-y-4">
          <div>
            <Label className="text-xs">Avisar card parado após (dias)</Label>
            <Input type="number" min="1" max="60" value={cardParado} onChange={(e) => setCardParado(e.target.value)} className="h-8 text-xs" data-testid="settings-card-parado" />
            <p className="text-[10px] text-zinc-600 mt-1">Vale apenas da 1ª à 4ª mensagem. Qualquer ação zera a contagem.</p>
          </div>
          <div>
            <Label className="text-xs">DDD padrão (para telefones sem DDD)</Label>
            <Input value={ddd} onChange={(e) => setDdd(e.target.value.replace(/\D/g, "").slice(0, 2))} className="h-8 text-xs w-20" data-testid="settings-ddd" placeholder="11" />
          </div>
          <div>
            <Label className="text-xs">Intenções (serviços oferecidos)</Label>
            <div className="flex gap-2 mt-1">
              <Input value={novaInt} onChange={(e) => setNovaInt(e.target.value)} onKeyDown={(e) => e.key === "Enter" && (e.preventDefault(), addIntencao())} placeholder="Ex: Corte" className="h-8 text-xs flex-1" data-testid="settings-intencao-input" />
              <Button type="button" onClick={addIntencao} className="h-8 text-xs bg-zinc-800 hover:bg-zinc-700" data-testid="settings-intencao-add"><Plus className="h-3 w-3" /></Button>
            </div>
            <div className="flex flex-wrap gap-1.5 mt-2">
              {intencoes.map((i) => (
                <span key={i} className="inline-flex items-center gap-1 text-xs bg-zinc-800 text-zinc-200 px-2 py-1 rounded" data-testid={`settings-intencao-${i}`}>
                  {i}
                  <button type="button" onClick={() => setIntencoes(intencoes.filter((x) => x !== i))} className="text-zinc-500 hover:text-red-400"><X className="h-3 w-3" /></button>
                </span>
              ))}
            </div>
          </div>
          <Button onClick={save} disabled={saving} className="w-full bg-amber-500 hover:bg-amber-600 text-zinc-950 h-8 text-xs font-semibold" data-testid="settings-save">
            {saving ? "Salvando..." : "Salvar"}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
